import 'primeflex/primeflex.css';

export default function Footer() {
    return (
        <footer className="text-1" >
            <div
                className="p-4 md:p-6"
                style={{
                    background: 'linear-gradient(to bottom, #00b300, #003300)',
                }}
            >
                <div className="grid grid-nogutter md:grid-cols-3 gap-5 mb-5">
                    <div className="col-12 md:col-5">
                        <img
                            src="/images/logo2.png"
                            alt="SNS Green Blend"
                            className="flex justify-content-start md:justify-content-start"
                            style={{ width: '10rem', borderRadius: '0.7rem' }}
                        />
                        <p className="text-sm line-height-3 text-left md:text-left">
                            Committed to providing the purest, highest <br>
                            </br>quality coconut oil
                            made from fresh coconuts <br>
                            </br>using traditional methods.
                        </p>
                    </div>

                    <div className="col-12 md:col">
                        <h5 className="mb-3 font-bold">QUICK LINKS</h5>
                        <ul className="list-none p-0 m-0">
                            <li className="mb-2">
                                <a href="/" className="text-1 no-underline hover:underline">
                                    Home
                                </a>
                            </li>
                            <li className="mb-2">
                                <a href="#products" className="text-1 no-underline hover:underline"> {/* text-1 hover:underline */}
                                    Products
                                </a>
                            </li>
                            <li className="mb-2">
                                <a href="#benefits" className="text-1 no-underline hover:underline">
                                    Benefits
                                </a>
                            </li>
                            <li className="mb-2">
                                <a href="/policies" className="text-1 no-underline hover:underline"> 
                                    Privacy & Policies
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-12 md:col">
                        <h5 className="mb-3 font-bold">OUR CONTACTS</h5>
                        <p className="text-sm mb-2">
                            Address: Kattyawa, Eppawala, Sri Lanka
                        </p>
                        <p className="text-sm mb-2">Phone No: +94 77 123 4567</p>
                        <p className="text-sm">Email: info@snsgreenblend.com</p>
                    </div>
                </div>
                {/*
                <div className="text-center text-sm mt-3">
                    2025 © All Rights Reserved | SNS Green Blend | Designed & Developed by {' '}
                    <a
                        href="https://everefficient.lk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-underline"
                        style={{ color: '#ffffff' }}
                    >
                        EVER EFFICIENT Business Management (Pvt) Ltd
                    </a>
                </div> */}

                <div className="text-center text-sm mt-3">
                {new Date().getFullYear()} © All Rights Reserved | SNS Green Blend | 
                Designed & Developed by{" "}
                <a
                    href="https://everefficient.lk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="no-underline"
                    style={{ color: "#ffffff" }}
                >
                    EVER EFFICIENT Business Management (Pvt) Ltd
                </a>
                </div>


            </div>
        </footer>
    );
}